


































import Vue from 'vue'
import { defineComponent, ref, computed, watch } from '@vue/composition-api'
import { getTreeData } from './config'
import { TreeNode } from 'element-ui/types/tree'
import { updateProject, project } from '@/assets/project'
import { addBeforeValidate, addNode } from '@/assets/node'
import { setTabName, tabName, hideComponent } from '@/assets/tab'

export default defineComponent({
  name: 'component-library',
  setup (p, ctx) {
    const checkData = ref<{ [k: string]: Array<string> }>({})
    watch(() => project.componentLibrary, val => {
      checkData.value = { ...val }
    })
    const defaultCheck = computed(() => {
      const res: string[] = []
      Object.keys(checkData.value).forEach(x => {
        checkData.value[x].forEach(y => {
          res.push(`${x}-${y}`)
        })
      })
      return res
    })
    const handleCheck = (data: { label: string, library: string }, check: boolean) => {
      if (!checkData.value[data.library]) {
        Vue.set(checkData.value, data.library, [])
      }
      if (check) {
        checkData.value[data.library].push(data.label)
      } else {
        const i = checkData.value[data.library].findIndex(x => x === data.label)
        checkData.value[data.library].splice(i, 1)
      }
      updateProject({ componentLibrary: checkData.value })
    }
    const handleDisabled = (
      data: { label: string },
      node: TreeNode<string, { label: string }>
    ) => {
      return node.level === 1
    }
    const handleAdd = (library: string, name: string) => {
      if (addBeforeValidate()) {
        addNode({ library, name, nodeType: 1 << 2, type: 'div', subType: 'spa' })
        setTabName([tabName.nodeTree, '', tabName.nodeProperty, '', tabName.pageSetTree, tabName.nodeSetProperty])
        hideComponent(true)
        ctx.emit('hide')
      }
    }

    return {
      defaultCheck,
      checkData,
      data: getTreeData(),
      handleCheck,
      handleDisabled,
      handleAdd
    }
  }
})
